import React from 'react';
import { motion } from 'framer-motion';
export function Timeline() {
  const days = [{
    day: 'Día 1',
    desc: "Instalás la 'zona de rascado competidora' y bloqueás el sillón."
  }, {
    day: 'Día 3',
    desc: 'Tu gato empieza a usar las alturas (estantes/heladera) y deja de atacarte los tobillos.'
  }, {
    day: 'Día 7',
    desc: 'Establecés el ritual de juego nocturno y dormís la noche entera sin maullidos.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-158">
          <h2 className="text-3xl md:text-4xl mb-4" data-id="element-159">Qué cambia en 7 días</h2>
          <p className="text-xl text-warmBrown/70" data-id="element-160">
            Resultados reales, sin magia.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-161">
          {days.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col sm:flex-row items-start sm:items-center gap-6 bg-cream p-6 md:p-8 rounded-3xl" data-id="element-162">
              <div className="bg-amber text-white font-heading text-2xl py-3 px-6 rounded-2xl shrink-0 shadow-sm" data-id="element-163">
                {item.day}
              </div>
              <p className="text-lg md:text-xl text-warmBrown/90 font-medium" data-id="element-164">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}